module.exports = __webpack_public_path__ + "img/onevone.28b0a841.png";